import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Typography,
  useMediaQuery,
  Grid, // ⬅️ added
} from "@mui/material";
// ⬇️ removed ReusableCarousel + responsiveReviewsV2 imports
import theme from "../../elements/Theme";
import TestimonialCard from "../../elements/TestimonialCard";
import { reviews } from "../../data/reviews";
import OrangeHighlightButton from "../../elements/OrangeHighlightButton";
import { useHistory } from "react-router-dom";

const ReviewsV2ListFrame: React.FC = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const history = useHistory();

  const renderTestimonialCard = (review: any, index: number) => (
    <Card
      key={index}
      sx={{
        color: "black",
        boxShadow: "none",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        margin: "0 10px",
        padding: "2% 2%",
        backgroundColor: "transparent",
        border: "none",
        width: isMobile ? "90%" : "100%",
        height: "100%",
      }}
    >
      <TestimonialCard
        name={t(`ReviewsV2Frame.reviews.review_${review.id}.${review.nameKey}`)}
        // keep your existing key; convert to number in case i18n returns string
        rating={Number(
          t(`ReviewsV2Frame.reviews.review_${review.id}.${review.raitingKey}`)
        )}
        quote={t(`ReviewsV2Frame.reviews.review_${review.id}.${review.quoteKey}`)}
      />
    </Card>
  );

  const handleRedirection = () => {
    const path =
      currentLanguage === "en" ? "/reviews" : `/${currentLanguage}/reviews`;
    history.push(path);
  };

  return (
    <>
      <Divider
        sx={{
          borderColor: theme.palette.text.secondary,
          borderBottomWidth: "3px",
        }}
      />
      <Box
        sx={{
          backgroundColor: "rgb(255 154 49 / 5%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: isMobile ? "5vh" : "10vh",
        }}
      >
        <Typography
          variant="h2"
          fontWeight="800"
          color={theme.palette.text.secondary}
          textAlign="center"
          mb="1vh"
        >
          {t("ReviewsV2Frame.title")}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "90%",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">{t("ReviewsV2Frame.subtitle")}</Typography>
        </Box>

        <Box
          width={isMobile ? "100%" : "80%"}
          paddingTop={"2%"}
          paddingBottom={"4%"}
          paddingLeft={"4%"}
          paddingRight={"4%"}
        >
          {/* ⬇️ Replaced carousel with a 3-column responsive grid */}
          <Grid container spacing={3}>
            {reviews.map((review: any, index: number) => (
              <Grid item xs={12} sm={6} md={4} key={review?.id ?? index}>
                {renderTestimonialCard(review, index)}
              </Grid>
            ))}
          </Grid>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              alignItems: "center",
            }}
          >
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ReviewsV2ListFrame;
